import { IconType } from "../../components/icons/icon-render";

export interface HeaderNavItem {
  label: string;
  href: string;
  icon: IconType | undefined;
}

interface HeaderModel {
  nav: HeaderNavItem[];
}

const headerModel: HeaderModel = {
  nav: [
    {
      label: 'Profile',
      href: '#profile',
      icon: undefined,
    },
    {
      label: 'projects',
      href: '#projects',
      icon: undefined,
    },
    {
      label: 'Skills',
      href: '#skills',
      icon: undefined,
    },
    {
      label: 'Contact',
      href: '#contact',
      icon: undefined,
    },
    {
      label: 'Curriculum',
      href: '#curriculum',
      icon: 'Download',
    },
  ]
};

export default headerModel;